import React, { useEffect, useRef, useState } from 'react';
import './style.css';
import cidadesEstadosService from '../../services/cidades-estados/cidades-estados-service';
import RestricaoTipoPagamentoService from '../../services/restricaoTipoPagamento';
import { DataTable } from 'primereact/datatable';
import { Column } from 'primereact/column';
import { MdDeleteForever, MdRemoveRedEye } from 'react-icons/md';
import ModalDetalharRegras from './components/ModalDetalharRegras';
import DialogSuccessNoReload from '../dialogs/dialog-sucesso-sem-reload';
import DialogErrorNoReload from '../dialogs/dialog-error-sem-reload';
import DialogAvisoSemReload from '../dialogs/dialog-aviso-sem-reload';

export default function RegularPagamentosBloqueados() {
    let dt = useRef(null);
    const [globalFilter, setGlobalFilter] = useState();
    const [showModalDetalheRegra, setShowModalDetalheRegra] = useState(false)
    const [dadosRegraSelecionada, setDadosRegraSelecionada] = useState([])
    const [regrasRestritas, setRegrasRestritas] = useState([])
    const [regrasParaDeletar, setRegrasParaDeletar] = useState([])
    const [regrasSelecionadasTabela, setRegrasSelecionadasTabela] = useState([])
    const [loadingRequest, setLoadingRequest] = useState(false)
    const [openDialogSuccess, setOpenDialogSuccess] = useState(false)
    const [openDialogError, setOpenDialogError] = useState(false)
    const [openDialogWarning, setOpenDialogWarning] = useState(false)
    const [confirmarDelete, setConfirmarDelete] = useState(false)

    useEffect(() => {
        (async () => {
            const responseRegras = await RestricaoTipoPagamentoService.getRestricoesPagamento()
            setRegrasRestritas(responseRegras)
        })();

    }, [loadingRequest])



    const montaArrayString = (array) => {
        let primeiro = true;
        let arrayString;

        if (!Array.isArray(array) || array.length === 0) {
            return 'Todos os Estados';
        }
        for (const [index, item] of array.entries()) {
            if (primeiro) {
                arrayString = item;
                primeiro = false;
            } else if (index === 15) {
                arrayString = arrayString + `... + ${array.length - 15} registro(s)`;
                return arrayString;
            } else {
                arrayString = arrayString + `, ${item}`;
            }
        }
        return arrayString;
    };

    const montaArrayStringComMarcacao = (array) => {
        let primeiro = true;
        let arrayString;

        if (!Array.isArray(array) || array.length === 0) {
            return 'Todos(as)';
        }

        for (const [index, item] of array.entries()) {
            if (primeiro) {
                arrayString = item.label;
                primeiro = false;
            } else if (index === 15) {
                arrayString = arrayString + `... + ${array.length - 15} registro(s)`;
                return arrayString;
            } else {
                arrayString = arrayString + `, ${item.label}`;
            }
        }
        return arrayString;
    };
    const montarArrayEstado = (array) => {
        let primeiro = true;
        let arrayString;

        if (!Array.isArray(array) || array.length === 0 || array[0] === "Todos Estados") {
            return 'Todos os Estados';
        }

        for (const [index, item] of array.entries()) {
            if (primeiro) {
                arrayString = item
                primeiro = false;
            } else if (index === 15) {
                arrayString = arrayString + `... + ${array.length - 15} registro(s)`;
                return arrayString;
            } else {
                arrayString = arrayString + `, ${item}`;
            }
        }
        return arrayString;
    };
    const montarArrayStringCidade = (array) => {
        let primeiro = true;
        let arrayString;

        if (!Array.isArray(array) || array.length === 0 || array[0] === "Todas as Cidades") {
            return 'Todas as Cidades';
        }

        for (const [index, item] of array.entries()) {
            if (primeiro) {
                arrayString = item
                primeiro = false;
            } else if (index === 15) {
                arrayString = arrayString + `... + ${array.length - 15} registro(s)`;
                return arrayString;
            } else {
                arrayString = arrayString + `, ${item}`;
            }
        }
        return arrayString;
    };
    const montarArrayStringPlanos = (array) => {
        let primeiro = true;
        let arrayString;

        if (!Array.isArray(array) || array.length === 0 || array[0] === "Todos Planos") {
            return 'Todos os Planos';
        }

        for (const [index, item] of array.entries()) {
            if (primeiro) {
                arrayString = item
                primeiro = false;
            } else if (index === 15) {
                arrayString = arrayString + `... + ${array.length - 15} registro(s)`;
                return arrayString;
            } else {
                arrayString = arrayString + `, ${item}`;
            }
        }
        return arrayString;
    };
    const renderHeaderListaBloqueados = () => {
        return (

            <div className="header-table-cadastro-edicao-precos">
                <div className="title-header-table-cadastro">
                    <h2>Restrições Ativas</h2>
                    <p>Todos os métodos abaixo estão com restrições de pagamento</p>
                </div>
                <div className="menu-header-table-cadastro">
                    <button
                        disabled={regrasSelecionadasTabela.length === 0}
                        onClick={handleHideDialogConfirmarDeletar}
                    >
                        <MdDeleteForever size={20} color="white" />
                        <span>Deletar selecionados</span>
                    </button>
                </div>
            </div>
        );
    };

    const estadosbodyTemplate = (rowData) => {
        const arrayEstados = rowData.estados.split(",")
        return <span>{montarArrayEstado(arrayEstados)}</span>;
    };

    const tipoPagamentosbodyTemplate = (rowData) => {
        return <span>{rowData.formaPagamento}</span>;
    };

    const planosbodyTemplate = (rowData) => {
        const arrayPlanos = rowData.planos.split(",")
        return <span>{montarArrayStringPlanos(arrayPlanos)}</span>;
    };

    const cidadesBodyTemplate = (rowData) => {
        const arrayCidades = rowData.cidades.split(',')
        return <span>{montarArrayStringCidade(arrayCidades)}</span>;
    };
    const acoesManutencaoRegra = (rowData) => {
        return (
            <div className="p-grid p-fluid">
                <div className="p-col-12 p-md-6 p-lg-6 p-sm-6">
                    <button
                        className='button-detail'

                        onClick={detalheRegra.bind(this, rowData)}
                    >
                        <MdRemoveRedEye size={20} color="white" />
                        <span>Detalhar</span>
                    </button>
                </div>
                <div className="p-col-12 p-md-6 p-lg-6 p-sm-6">
                    <button className='button-delete'

                
                        onClick={handleHideDialogConfirmarDeletar.bind(this,rowData)}
                    >
                        <MdDeleteForever size={20} color="white" />
                        <span>Deletar</span>
                    </button>
                </div>
            </div>
        );
    };

    const clientesbodyTemplate = (rowData) => {
        const arrayInscricoes = rowData.inscricoes.split(",")
        return (

            <span>
                {Array.isArray(arrayInscricoes)
                    ? montaArrayString(arrayInscricoes)
                    : rowData.clientes}
            </span>
        );
    };
    const detalheRegra = (rowData) => {
        setShowModalDetalheRegra(true)
        setDadosRegraSelecionada(rowData)

    }

    const handleHideDialogConfirmarDeletar = async (rowData) => {
        setOpenDialogWarning(true)
        if (rowData.idRegra) {
            const objArrayRegras = {
                arrayRegras: [rowData.idRegra]
            }
            setRegrasParaDeletar(objArrayRegras)
        }

    }
    const onDelete = async () => {
        try {

            setLoadingRequest(true)

            await RestricaoTipoPagamentoService.deletarRestricoesPagamento(regrasParaDeletar)


            setLoadingRequest(false)
            setOpenDialogSuccess(true)

        } catch (error) {
            setLoadingRequest(false)
            setOpenDialogError(true)
            return
        }



    }
    useEffect(() => {
        if (confirmarDelete) {
            onDelete()
            setRegrasParaDeletar([])
        }
    }, [confirmarDelete])

    const handleDeleteChange = (e) => {
        const arrayRegras = e.value.map(rowData => rowData.idRegra)
        const objIdRegras = {
            arrayRegras: arrayRegras
        }
        setRegrasParaDeletar(objIdRegras);
        setRegrasSelecionadasTabela(e.value)
    };
    return (
        <div className="page-regular-pagamentos-bloqueados">
            <div>
                <DialogAvisoSemReload onHide={handleHideDialogConfirmarDeletar} messageHeader='Atenção!' messageBody='Deseja realmente realizar esta exclusão?' openDialog={openDialogWarning} setOpenDialog={setOpenDialogWarning} confirmacaoDelete={setConfirmarDelete} />
                <ModalDetalharRegras dadosRegra={dadosRegraSelecionada} isVisible={showModalDetalheRegra} fecharModalAviso={setShowModalDetalheRegra} />
                <DataTable
                    ref={dt}
                    value={regrasRestritas}
                    loading={loadingRequest}
                    responsive
                    dataKey="idRegra"
                    rowHover
                    globalFilter={globalFilter}
                    header={renderHeaderListaBloqueados()}
                    paginator
                    rows={5}
                    selection={regrasSelecionadasTabela} onSelectionChange={handleDeleteChange}
                    emptyMessage="Ainda não há restrições"
                    currentPageReportTemplate="Exibindo {first} a {last} de {totalRecords} resultados encontrados"
                    paginatorTemplate="FirstPageLink PrevPageLink PageLinks NextPageLink LastPageLink CurrentPageReport RowsPerPageDropdown"
                    rowsPerPageOptions={[5, 10]}
                >
                    <Column
                        selectionMode="multiple"
                        style={{ width: '3em' }}
                    />
                    <Column
                        field="formaPagamento"
                        header="Forma de Pagamento"
                        body={tipoPagamentosbodyTemplate}
                        filter
                        filterPlaceholder="Buscar forma de pagamento dentre as selecionadas"
                    />
                    <Column
                        field="estados"
                        header="Estado"
                        body={estadosbodyTemplate}
                        filter
                        filterPlaceholder="Buscar estado dentre os selecionados"
                    />
                    <Column
                        field="cidades"
                        header="Cidade"
                        body={cidadesBodyTemplate}
                        filter
                        filterPlaceholder="Buscar cidade dentre as selecionadas"
                    />
                    <Column
                        field="planos"
                        header="Plano"
                        body={planosbodyTemplate}
                        filter
                        filterPlaceholder="Buscar plano dentre os selecionados"
                    />
                    <Column
                        field="inscricoes"
                        header="Clientes"
                        body={clientesbodyTemplate}
                        filter
                        filterPlaceholder="Buscar plano dentre os selecionados"
                    />
                    <Column

                        header="Ações"
                        body={acoesManutencaoRegra}
                        headerStyle={{
                            width: '14em',
                            textAlign: 'center',
                        }}
                        bodyStyle={{
                            textAlign: 'center',
                            overflow: 'visible',
                        }}
                    />
                </DataTable>
            </div>
            <DialogSuccessNoReload messageHeader='Exclusão das regras realizadas com sucesso' messageBody='Todas as alterações foram salvas!' openDialog={openDialogSuccess} setOpenDialog={setOpenDialogSuccess} />
            <DialogErrorNoReload messageHeader='Nenhuma alteração realizada!' messageBody='Houve um problema ao salvar as alterações, tente novamente!' openDialog={openDialogError} setOpenDialog={setOpenDialogError} />
        </div>
    );
}
